<template>
  <el-menu
    default-active="1-1"
    class="el-menu-vertical-demo"
    background-color="#001529"
    text-color="#fff"
    active-text-color="#ffd04b"
    :collapse="collapse"
  >
    <!-- 遍历模版 -->
    <el-submenu v-for="(item, index) in menus" :key="index" :index="`${index + 1}`">
      <template slot="title">
        <i :class="item.icon"></i>
        <span>{{item.name}}</span>
      </template>
      <!-- 导航子项部分 -->
      <el-menu-item
        v-for="(subItem, subIndex) in item.children"
        :key="subIndex"
        :index="`${index + 1}-${subIndex + 1}`"
      >
        <router-link :to="subItem.src">{{subItem.name}}</router-link>
      </el-menu-item>
      <!-- 导航子项部分-->
    </el-submenu>
  </el-menu>
</template>

<script>
export default {
  data() {
    return {
      // 侧边栏菜单
      menus: [
        {
          icon: "el-icon-home",
          
          children:[
            {
              name: "统计",
              src: "/admin/home"
            }
          ]
        },
        {
          icon: "el-icon-setting",
          name: "首页管理",
          children: [
            {
              name: "首页广告",
              src: "/admin/homebanner"
            },
            {
              name: "首页推荐",
              src: "/admin/homerecommend"
            }

          ]
        },
        {
          icon: "el-icon-s-goods",
          name: "购物商场",
          children: [
            // {
            //   name: "首页",
            //   src: "/admin/home"
            // },
            {
              name:"订单管理",
              src:"/admin/orderlist"

            },
            {
              name: "商品管理",
              src: "/admin/goodslist"
            },
            {
              name: "栏目管理",
              src: "/admin/categorylist"
            },
            {
              name:'咨询管理',
              src:"/admin/consultlist"
            },
            {
              name:'多语言管理',
              src:"/admin/languagelist"
            },
            {
              name:'公告管理',
              src:"/admin/noticelist"
            },
            {
               name:'邮件通知管理',
               src:"/admin/mailnotify"  
            }
          ]
        },
        // {
        //   icon: "el-icon-s-order",
        //   name: "商城订单",
        //   children: [
        //     {
        //       name: "订单管理",
        //       src: "/admin/orderlist"
        //     }
        //   ]
        // },
        // {
        //   icon: "el-icon-user-solid",
        //   name: "会员管理",
        //   children: [
        //     {
        //       name: "会员列表",
        //       src: "/admin/accountlist"
        //     }
        //   ]
        // },
        // {
        //   icon: "el-icon-setting",
        //   name: "多语言",
        //   children: [
        //     {
        //       name: "多语言列表",
        //       src: "/admin/languagelist"
        //     }
        //   ]
        // }


        
      ]
    };
  },
  methods: {},
  //可以接受的属性
  props: {
    collapse: {
      // 属性的类型
      type: Boolean,
      // 默认值
      value: false
    }
  }
};
</script>

<style>
.el-menu:not(.el-menu--collapse) {
  width: 200px;
}
.el-menu {
  border: none;
}
.el-menu-item a {
  color: inherit;
  text-decoration: none;
}
</style>